import React, { PropTypes } from 'react';
import { Button, Modal } from 'react-bootstrap';
import '../../styles/LoadingModal';

let LoadingModal = React.createClass({
	propTypes: {
		iconClass: PropTypes.string,
		message: PropTypes.string,
		shouldShow: PropTypes.bool,
		subtitle: PropTypes.string
	},

	defaultProps: {
		iconClass: 'fas fa-cog fa-spin',
		message: 'Loading'
	},

	render: function() {
		return (
			<Modal className="loading-modal" show={ this.props.shouldShow }>
				<Modal.Header>
					<i className={ this.props.iconClass } />
					<div className="modal-title">
						{ this.props.message }
					</div>
					{
						this.props.subtitle ? (
							<div className="modal-subtitle">
								{ this.props.subtitle }
							</div>
						) : ''
					}
				</Modal.Header>
				<Modal.Footer>
				</Modal.Footer>
			</Modal>
		);
	}
});

module.exports = LoadingModal;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/LoadingModal.jsx